import { memo } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { DetailCard } from "./common";

interface DefaultDetailCardProps {
  recordType: string;
  displayName: string;
}

export const DefaultDetailCard = memo(
  ({ recordType, displayName }: DefaultDetailCardProps) => (
    <DetailCard>
      <Stack gap="sm" fullWidth>
        <Typography variant="bodyW2" className="font-semibold">
          Trigger Info
        </Typography>
        <Typography variant="bodyW3" textColor="secondary">
          {recordType}: {displayName}
        </Typography>
      </Stack>
    </DetailCard>
  ),
);

DefaultDetailCard.displayName = "DefaultDetailCard";
